export default __webpack_public_path__ + "static/media/usa.0ffbe89d.png";